
import * as config from './../config/config'
import moment from "moment";
import api from './interceptor'

export async function get_listeCamion() {
    try {
        const response = await api.get(config.REACT_APP_ENDPOINT_LIST_CAMION);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export async function createCamion(data) {
    try {
        const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_CAMION, {
            "imm": data['imm'],
            "reference": data['reference'],
            "marque": data['marque'],
            "imm_remorque": data['imm_rem'],
            "statut": "operationnelle",
            "kilometrage": data['kilometrage'],
            "carburant": data['carburant'],
            "fond_cuve": data['fond_cuve'],
            "date_visite_technique": data['lim_vt'],
            "date_assurance": data['lim_ass'],
            "energie_id": data['energie_id'],
            "type_id": data['type_id'],
            "chauffeur_id": data['chauffeur_id'],
            "site_id": data['site_id'],
            "appartenance_id": data['appartenance_id'],
            "images": data['images'],
            "intervalle_km_vidange": data['intervalle_km_vidange'],
            "dernier_km_vidange": data['dernier_km_vidange'],
            "dernier_date_vidange": data['dernier_date_vidange'],
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function updateCamion(data) {
    try {
        const response = await api.put(config.REACT_APP_ENDPOINT_UPDATE_CAMION + '/' +  data['id'], {
            "imm": data['imm'],
            "reference": data['reference'],
            "marque": data['marque'],
            "imm_remorque": data['imm_rem'],
            "statut": "operationnelle",
            "kilometrage": data['kilometrage'],
            "carburant": data['carburant'],
            "fond_cuve": data['fond_cuve'],
            "date_visite_technique": new Date(data['lim_vt']).toISOString().slice(0, 10),
            "date_assurance": new Date(data['lim_ass']).toISOString().slice(0, 10),
            "energie_id": data['energie_id'],
            "type_id": data['type_id'],
            "chauffeur_id": data['chauffeur_id'],
            "site_id": data['site_id'],
            "appartenance_id": data['appartenance_id'],
            "images": data['images'],
            "intervalle_km_vidange": data['intervalle_km_vidange'],
            "dernier_km_vidange": data['dernier_km_vidange'],
            "dernier_date_vidange": data['dernier_date_vidange'],
            "num_carte_grise": data['num_carte_grise'],
            "num_patente": data['num_patente']
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export async function disableCamion(camion_id) {
    try {
        const response = await api.delete(config.REACT_APP_ENDPOINT_DISABLE_CAMION + '/' + camion_id);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function exportCamion(camion_id, data) {
    try {
        const response = await api.post(
            `${config.REACT_APP_ENDPOINT_EXPORT_CAMION}/${camion_id}`,
            {
                "start": moment(data.dates[0]).format("YYYY-MM-DD HH:mm:ss"),
                "end": moment(data.dates[1]).format("YYYY-MM-DD HH:mm:ss"),
                "type": data['type']
            },
            {
                responseType: "blob", // ⚠️ important : on attend un fichier binaire
            }
        );

        // 🔽 Créer un lien de téléchargement temporaire
        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Récupérer le nom du fichier depuis les headers si le backend l’envoie
        const contentDisposition = response.headers["content-disposition"];
        console.log(contentDisposition);
        let fileName = "export_camion.xlsx";
        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) fileName = match[1];
        }

        // Créer une URL temporaire et déclencher le téléchargement
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        // Nettoyage
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        return true; // succès
    } catch (error) {
        console.error("Erreur lors de l'export du camion:", error);
        throw error;
    }
}

export async function getlocationCamion() {
    try {
        const response = await api.get(config.REACT_APP_ENDPOINT_LOCALISATION_CAMION);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function addCallibrage(camion_id, data) {
    try {
        const response = await api.post(config.REACT_APP_ENDPOINT_ADD_CALLIBRAGE_CAMION, {
            "x": data['x'],
            "y": data['y'],
            "camion_id": camion_id
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}